<template>
  <section class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>{{ t('label_interpretation_model') }}</h3>
      <h4 class="medium">
        <AnimationTyping :text="t('onboarding_choose_interpretation_type')" />
      </h4>
    </div>
    <div class="wrapper-content-detail fadeinOnboarding">
      <label class="radio-option" v-for="option in INTERPRETATION_OPTIONS" :key="option.value">
        <input v-model="form.callType" type="radio" name="interpreter-type" :value="option.value" />
        <div class="radio-box radio-box-primary">
          {{ option.label }}
        </div>
      </label>
    </div>
    <a class="link-dashboard fadeinOnboarding" @click.prevent="emit('moveDashboard')">
      {{ t('skip') }}
    </a>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import { ISelfServiceOnboardingForm } from '@/types/components';

const { t } = useI18n();

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});

// 통역 모드 옵션 목록
const INTERPRETATION_OPTIONS = [
  { value: 'MEETING', label: t('onboarding_meeting') },
  { value: 'CONFERENCE', label: t('onboarding_conference') },
  { value: 'AUDIENCE', label: t('onboarding_audience') },
  { value: 'GENERAL', label: t('onboarding_general') },
  { value: 'SINGLE', label: t('onboarding_one_to_one') },
];

const emit = defineEmits(['moveDashboard']);
</script>

<style scoped lang="scss">
@import '@/assets/sass/theme/_sconchat.scss';

.container-onboarding-content {
  .radio-option {
    width: 100%;
    .radio-box {
      width: 100%;
      border-radius: 0.5rem;
    }
  }
}
</style>
